import React, { useState } from 'react'

interface IconButtonProps {
  onClick: () => void
  icon: React.ReactElement
  hoverIcon?: React.ReactElement
}

// TODO: move this to shared components package
const IconButton: React.FC<IconButtonProps> = (props) => {
  const [hover, setHover] = useState(false)

  return (
    <div
      onClick={props.onClick}
      onKeyPress={(): undefined => {
        return
      }}
      onMouseEnter={(): void => setHover(true)}
      onMouseLeave={(): void => setHover(false)}
      role="button"
      tabIndex={0}
    >
      {hover && props.hoverIcon ? props.hoverIcon : props.icon}
    </div>
  )
}

export default IconButton
